const CARDINALS = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];

const convertDirectionToCardinal = (value?: number | string) => {
    if (value === undefined) return '';
    const numberValue = ((parseFloat(value as string) % 360) + 360) % 360;
    const cardinalIndex = Math.floor((numberValue % 360) / 45 + 0.5);
    return CARDINALS[cardinalIndex % 8];
};

export { convertDirectionToCardinal };
